export const dealStatus = [
  { label: "Draft", value: 0, id: 65015 },
  { label: "Draft", value: 1, id: 65015 },
  { label: "Posted", value: 2, id: 65016 },
  { label: "Approved", value: 3, id: 65017 },
];
export const InvoiceStatus = [
  { label: "", value: 0, id: "" },
  { label: "Submitted", value: 1, id: 65005 },
  { label: "NotReady", value: 2, id: 65006 },
];
export const PaymentStatus = [
  { label: "", value: 0, id: "" },
  { label: "Pending", value: 1, id: 65009 },
  { label: "ReadyToRelease", value: 2, id: 65010 },
  { label: "Released", value: 3, id: 65011 },
];
export const CollectionStatus = [
  { label: "", value: 0, id: "" },
  { label: "Paid", value: 1, id: 65007 },
  { label: "Unpaid", value: 2, id: 65008 },
];
